// extracted by mini-css-extract-plugin
export default {"container":"loader_container__nciuW","logo":"loader_logo__eBT5T","spin":"loader_spin__FPhFu","pulse":"loader_pulse__QL--A","text":"loader_text__qxJ1o","fade":"loader_fade__5qoPD"};